var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotionFoggyBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 112,
    viewBox: "0 0 85 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17283_21675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 114,
    height: 114
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.614 0.475739C44.8949 9.54742 68.6609 27.4815 60.4288 45.0722C52.1967 62.6629 -2.05081 35.6575 0.0599821 72.8211C2.17078 109.985 72.1688 117.369 70.5606 85.7045C68.9524 54.0402 136.895 28.1009 102.039 23.5375C67.1844 18.9741 85.7584 4.93539 60.4288 0.475739C35.0992 -3.98391 -5.63826 24.0128 16.7362 38.3827C39.1106 52.7525 45.6561 106.269 65.9197 110.976C86.1834 115.684 113.815 103.767 109.821 83.2269C105.828 62.6867 71.9833 56.6822 71.9833 56.6822",
    stroke: "#83D9FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17283_21675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 0H0V112H112V0Z",
    fill: "url(#paint0_radial_17283_21675)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17283_21675",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(56 -0.120432 0.120951 56 56 56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DE8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE8AE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE8AE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionFoggyBackground);
export default __webpack_public_path__ + "static/media/promotion-foggy-background.b4556884b261a86fcd8f3ba48467fd12.svg";
export { ForwardRef as ReactComponent };